import { isBrowser } from "../../core/detection";

export function getUserAgent(): string {
  return isBrowser() ? window.navigator.userAgent : null;
}

export function detectBrowser(ua: string): string {
  if (!isBrowser() || !ua) { return; }
  const trident = ua.indexOf("Trident/");
  const edge = ua.indexOf("Edge/");

  if (trident > 0) {
    // IE 11 => return version number
    const rv: number = ua.indexOf("rv:");
    const ieVersion: number = parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
    return ieVersion === 11 ? "is-ie11" : null;
  }

  if (edge > 0) {
    // IE 12 (aka Edge) => return version number
    const ieVersion: number = parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
    return ieVersion >= 12 ? "is-edge" : null;
  }

  return;
}
